import { useRef, useState } from "react";
import useUploadMedia from "../file/useUploadMedia";
import toast from "react-hot-toast";

function useBlogImage({ onImageUploaded, onImageDeleted }) {
  const fileInputRef = useRef(null);
  const [imagePreview, setImagePreview] = useState(null);

  const { upload } = useUploadMedia({
    url: "upload-document",
    onSuccess: (res) => {
      // Access properties directly from the response object, not from res.data
      const { document_id, image_path } = res;
      setImagePreview(image_path);
      onImageUploaded(document_id, image_path);
      toast.success("Image uploaded successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: () => {
      toast.error("Image upload failed", {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  const handleOpenFileUploadDialog = () => {
    fileInputRef.current.click();
  };

  const handleUploadFile = (e) => {
    const file = e.target?.files[0];
    if (file) {
      upload.mutate(
        {
          file,
          type: "blogs",
        }
      );
    }
  };

  const handleDeleteImage = () => {
    setImagePreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    // Call the onImageDeleted callback to clear form data
    if (onImageDeleted) {
      onImageDeleted();
    }
  };

  return {
    fileInputRef,
    imagePreview,
    setImagePreview,
    isUploading: upload.isLoading,
    handleOpenFileUploadDialog,
    handleUploadFile,
    handleDeleteImage,
  };
}

export default useBlogImage;
